import { useEffect, useState } from 'react';
import { Search, Users, ShieldAlert, Wallet } from 'lucide-react';
import { api } from '../api';

export const BAND = { A: '#2E9E6A', B: '#6FA640', C: '#C9A227', D: '#D9822B', E: '#C2423A' };
export const bandOf = (r) => BAND[String(r || '').toUpperCase()] || '#8A8F97';

export const QUICK = [
  { to: '/portal/ricerca', icon: Search, label: "Cerca un'azienda", id: 'search' },
  { to: '/portal/persone', icon: Users, label: 'Cerca una persona', id: 'people' },
  { to: '/portal/reputational', icon: ShieldAlert, label: 'Avvia un reputational check', id: 'reputational' },
  { to: '/portal/plafond', icon: Wallet, label: 'Ricarica il plafond', id: 'wallet' },
];

export const todayLong = () => {
  const s = new Date().toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString('it-IT') : '');

export function useDashboardData() {
  const [reports, setReports] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [monitored, setMonitored] = useState(0);
  const [checks, setChecks] = useState(0);

  useEffect(() => {
    api.get('/cs/reports').then((r) => setReports(r.data)).catch(() => {});
    api.get('/wallet').then((r) => setLedger(r.data.ledger)).catch(() => {});
    api.get('/monitoring/count').then((r) => setMonitored(r.data.total || 0)).catch(() => {});
    api.get('/aml/checks').then((r) => setChecks(r.data.length)).catch(() => {});
  }, []);

  const spent = ledger.reduce((s, l) => {
    if (l.meta?.admin) return s;
    if (l.type === 'debit') return s + l.amount_cents;
    return (l.reason || '').startsWith('Rimborso') ? s - l.amount_cents : s;
  }, 0);
  const dist = ['A', 'B', 'C', 'D', 'E'].map((k) => [k, reports.filter((r) => String(r.rating || '').toUpperCase() === k).length]);

  return { reports, spent, monitored, checks, dist };
}
